import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import LoadingScreen from 'components/Shared/LoadingScreen';
import Button from 'uikit/Button';

import Empty from './Empty';
import GameCard from './GameCard';
import GameCreate from './GameCreate';
import GameDelete from './GameDelete';
import GameUpdate from './GameUpdate';
import styles from './Games.module.scss';

const cx = classNames.bind(styles);

const Games = ({
  className,
  course,
  handleGameCreate,
  isEmpty,
  isLoading,
  t,
}) =>
  isLoading ? (
    <LoadingScreen />
  ) : (
    <>
      <div className={cx('container', className)}>
        <div className={cx('header')}>
          <h3 className={cx('title')}>
            {t('Course/Teacher/Games/title')}
            <span className={cx('count')}>{course.games.length}</span>
          </h3>
          <Button icon="plus" intent="white" onClick={handleGameCreate}>
            {t('Course/Teacher/Games/create-game')}
          </Button>
        </div>
        {isEmpty && <Empty />}
        {course.games.map((game) => (
          <GameCard className={cx('game')} game={game} key={game.id} />
        ))}
      </div>
      <GameCreate course={course} />
      <GameDelete />
      <GameUpdate course={course} />
    </>
  );

Games.propTypes = {
  className: PropTypes.string,
  course: PropTypes.object,
  handleGameCreate: PropTypes.func.isRequired,
  isEmpty: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

Games.defaultProps = {
  className: undefined,
  course: undefined,
};

export default Games;
